export default __webpack_public_path__ + "static/media/footer_bg.2d47ac38.svg";